<template>
  <span>{{ convertedText }}</span>
</template>

<script>
import { computed } from 'vue'
import { convertToTraditional } from '@/utils/textConverter'

export default {
  name: 'TText',
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup(props) {
    // 將輸入的文本轉換為繁體中文
    const convertedText = computed(() => {
      if (!props.text) return '';
      return convertToTraditional(props.text)
    })
    
    return {
      convertedText
    }
  }
}
</script> 